<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_193_10473)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_193_10473)" />
    </g>
    <g clip-path="url(#clip0_193_10473)">
      <path
        d="M23 21.5H11C10.7349 21.4997 10.4807 21.3943 10.2932 21.2068C10.1057 21.0193 10.0003 20.7651 10 20.5V17.5C10.0003 17.2349 10.1057 16.9807 10.2932 16.7932C10.4807 16.6057 10.7349 16.5003 11 16.5H23C23.2651 16.5003 23.5193 16.6057 23.7068 16.7932C23.8943 16.9807 23.9997 17.2349 24 17.5V20.5C23.9997 20.7651 23.8943 21.0193 23.7068 21.2068C23.5193 21.3943 23.2651 21.4997 23 21.5ZM11 17.5V20.5H23V17.5H11Z"
        fill="white" />
      <path d="M12 18.5H19V19.5H12V18.5Z" fill="white" />
    </g>
    <defs>
      <filter id="filter0_d_193_10473"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.117647 0 0 0 0 0.294118 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_193_10473" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_193_10473" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_193_10473"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#9300AB" />
        <stop offset="1" stop-color="#DB00FF" />
      </linearGradient>
      <clipPath id="clip0_193_10473">
        <rect width="16" height="16" fill="white" transform="translate(8 11)" />
      </clipPath>
    </defs>
  </svg>
</template>
